import { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Joyride, EventData, Controls, STATUS, EVENTS } from "react-joyride";
import Header from "./Header/Header";
import Sidebar from "./LeftMenu/Sidebar";
import WelcomeModal from "./Onboarding/WelcomeModal";
import CompletionModal from "./Onboarding/CompletionModal";
import OnboardingTooltip from "./Onboarding/OnboardingTooltip";
import { getOnboardingSteps } from "./Onboarding/onboardingSteps";
import { useOnboarding } from "../context/OnboardingContext";

const Main = () => {
  const { runTour, setRunTour, stepIndex, setStepIndex, completeTour, showCompletionModal, dismissCompletion } = useOnboarding();
  const menuList = useSelector((state: any) => state.items?.menuList);
  const navigate = useNavigate();
  const location = useLocation();

  const steps = getOnboardingSteps(menuList || []);

  const handleJoyrideEvent = (data: EventData, controls: Controls) => {
    const { status, action, index, type } = data;

    // Tour finished or skipped
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      completeTour();
      return;
    }

    // Step navigation
    if (type === EVENTS.STEP_AFTER) {
      const nextIndex = action === 'next' ? index + 1 : index - 1;
      const nextStep = steps[nextIndex];

      if (nextStep && nextStep.route && nextStep.route !== location.pathname) {
        navigate(nextStep.route);
        window.scrollTo({ top: 0, behavior: 'instant' });
        setTimeout(() => {
          setStepIndex(nextIndex);
        }, 50);
      } else {
        if (action === 'next') {
          setStepIndex(index + 1);
        } else if (action === 'prev') {
          setStepIndex(index - 1);
        }
      }
    }

    // Close button
    if (action === 'close') {
      completeTour();
    }
  };

  const selectedOutlet = useSelector((state: any) => state?.items?.storeSelectedOutlet);
  const outletId = selectedOutlet?.[0]?.id || localStorage.getItem("outlet_id") || "";

  return (
    <>
      <Header />
      <div id="main-app" className="layout-veritcle-menu">
        {/* <VerticalMenu /> */}
        <Sidebar />
        <div className="app-body ">
          <Outlet key={outletId} />
        </div>
      </div>

      {/* Onboarding */}
      <WelcomeModal />
      <CompletionModal show={showCompletionModal} onClose={dismissCompletion} />
      <Joyride
        steps={steps}
        run={runTour}
        stepIndex={stepIndex}
        continuous
        onEvent={handleJoyrideEvent}
        tooltipComponent={OnboardingTooltip}
        options={{
          overlayClickAction: false,
          buttons: ['back', 'primary', 'skip', 'close'],
          overlayColor: 'rgba(15, 3, 4, 0.78)',
          zIndex: 10000,
          arrowColor: 'rgba(22, 27, 45, 0.92)',
          closeButtonAction: 'skip',
          spotlightRadius: 12,
          scrollOffset: 120,
        }}
      />
    </>
  );
};

export default Main;
